
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Home, Building, Shield, Zap } from 'lucide-react';

const MaterialsOverview = () => {
  const materials = [
    {
      icon: <Home className="h-8 w-8 text-brand-safety-orange" />,
      title: "Asphalt Shingles",
      description: "Most popular residential roofing material offering excellent value and durability",
      features: [
        "GAF Timberline HDZ shingles",
        "Owens Corning Duration series",
        "CertainTeed Landmark collection",
        "25-50 year warranties available"
      ]
    },
    {
      icon: <Building className="h-8 w-8 text-brand-safety-orange" />,
      title: "Metal Roofing",
      description: "Long-lasting, energy-efficient solution for residential and commercial properties",
      features: [
        "Standing seam systems",
        "Corrugated metal panels",
        "Aluminum and steel options",
        "50+ year lifespan"
      ]
    },
    {
      icon: <Shield className="h-8 w-8 text-brand-safety-orange" />,
      title: "TPO Membrane",
      description: "Commercial-grade single-ply membrane for flat and low-slope roofs",
      features: [
        "Energy-efficient white membrane",
        "Heat-welded seams",
        "Chemical and UV resistant",
        "15-20 year warranties"
      ]
    },
    {
      icon: <Zap className="h-8 w-8 text-brand-safety-orange" />,
      title: "EPDM Rubber",
      description: "Proven commercial roofing solution with excellent weather resistance",
      features: [
        "Firestone UltraPly systems",
        "Ballasted or fully adhered",
        "Superior weather resistance",
        "20+ year performance"
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4">Professional Roofing Materials</h2>
          <p className="text-lg text-gray-600">
            We work exclusively with top-tier manufacturers to ensure your roof provides 
            decades of reliable protection with industry-leading warranties.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {materials.map((material, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="text-center">
                <div className="flex justify-center mb-4">
                  {material.icon}
                </div>
                <CardTitle className="text-xl">{material.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-gray-600 mb-4">{material.description}</p>
                <ul className="space-y-2">
                  {material.features.map((feature, idx) => (
                    <li key={idx} className="text-sm flex items-start">
                      <span className="text-brand-safety-orange mr-2">•</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MaterialsOverview;
